import { Box, Container, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { MessageAlert } from '../components/alerts/MessageAlert.component';
import Recorder from '../components/recorder/Recorder.component';
import { RecordingData } from '../helpers/recordingData';

interface MicTestingPageProps {
    displayMessageAlert: (message: string, title?: string) => void;
}

export const MicTestingPage = ({
    displayMessageAlert,
}: MicTestingPageProps) => {
    const [recordingBlob, setRecordingBlob] = useState<Blob>();

    const PromptText = () => {
        return (
            <Container>
                <Typography variant="h5" fontWeight="fontWeightBold">
                    You will have to use your microphone for this activity. To
                    test your microphone, click on the microphone icon below. If
                    you can clearly hear your voice, click ‘next’ to proceed.
                </Typography>
            </Container>
        );
    };

    const Instructions = () => {
        return (
            <Container sx={{ marginBottom: '14%', marginTop: '1%' }}>
                <Typography
                    variant="body1"
                    sx={{ color: 'primary.dark', margin: 2 }}
                    fontWeight="fontWeightBold"
                >
                    To start testing, you will have to grant access. Usually the
                    browser asks for permission somewhere at the top of the
                    browser or screen. If it doesn't work, check your system
                    settings and browser microphone permissions.
                </Typography>
            </Container>
        );
    };

    return (
        <Container
            sx={{
                flex: 1,
                display: 'flex',
                flexDirection: 'column',
                justifyContent: 'center',
                textAlign: 'center',
                marginBottom: 3,
            }}
        >
            <PromptText />
            <Instructions />
            <Box>
                <Typography
                    variant="body2"
                    sx={{ color: 'primary.dark', margin: 2 }}
                    fontWeight="fontWeightBold"
                >
                    Click to test out microphone.
                </Typography>
                <Recorder
                    setRecordingBlob={setRecordingBlob}
                    displayMessageAlert={displayMessageAlert}
                />
            </Box>
        </Container>
    );
};
